import axios from '@/plugins/axios'

const getLogin = (formData) => axios.post('login', formData)
const getLogout = () => axios.post('logout')

export {
    getLogin,
    getLogout,
}
